// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".FormatBar {\n  /* margin-top: 5px; */\n}\n\n.FormatBar .ImageButton {\n  margin-bottom: 2px;\n}\n", "",{"version":3,"sources":["/apps/proksee/project/releases/20250624162016/app/javascript/proksee-viewer/containers/FormatBar.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB","file":"FormatBar.css","sourcesContent":[".FormatBar {\n  /* margin-top: 5px; */\n}\n\n.FormatBar .ImageButton {\n  margin-bottom: 2px;\n}\n"]}]);
// Exports
module.exports = exports;
